module.exports = __webpack_public_path__ + "static/media/adressIcon.e4bbbc5c.svg";